import { IAuditModel } from './base';
import { IMasterNamePerson } from './master.names';
import { IUser } from './user';

export enum SexOffenderRiskLevel {
  PENDING = 0,
  LEVEL_1 = 1,
  LEVEL_2 = 2,
  LEVEL_3 = 3,
}

export const RiskLevelLabels: Record<number, string> = {
  0: 'Pending',
  1: 'Level 1',
  2: 'Level 2',
  3: 'Level 3',
};

export interface ISexOffenderCheckin extends IAuditModel {
  sexOffenderId: string;
  officerId: IUser | string;
  dateTime: string;
  note?: string;
}

export interface ISexOffender extends IAuditModel {
  personId: string | IMasterNamePerson;
  person: IMasterNamePerson;
  sexOffenderId: string;
  riskLevel: SexOffenderRiskLevel;
  assignedOfficerId: string | IUser;
  assignedOfficer: IUser;
  checkInFrequencyDays: number;
  active: boolean;
  notificationsEnabled: boolean;
  nextDueDate?: string;
  isOverdue: boolean;
  checkins?: ISexOffenderCheckin[];
}
